const HEADER_HEIGHT = 55;

export default HEADER_HEIGHT;
